module.exports = __webpack_public_path__ + "img/maker_petroval.3dba3ab3.jpg";